import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=0b972eea&scoped=true"
import script from "./cardList.vue?vue&type=script&lang=js"
export * from "./cardList.vue?vue&type=script&lang=js"
import style0 from "./cardList.vue?vue&type=style&index=0&id=0b972eea&prod&scoped=true&lang=css"
import style1 from "./cardList.vue?vue&type=style&index=1&id=0b972eea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b972eea",
  null
  
)

export default component.exports